import { usePopups } from '@mm-frontend/mm-web-ui-kit';
import CitiesModal from '../ui/CitiesModal.vue';

const { createPopup } = usePopups();

const selectCityPopup = createPopup({
  component: CitiesModal
})

export function useCitiesModal() {
  function openCitiesModal() {
    selectCityPopup.show();
  }

  function closeCitiesModal() {
    selectCityPopup.close();
  }

  return {
    openCitiesModal,
    closeCitiesModal,
  };
}
